import { createContext } from "react";
import ILayerDataContext from './ILayerDataContext'

const defaultLayerDataContext: ILayerDataContext = {}

export const LayerDataContext = createContext(defaultLayerDataContext)
const LayerDataContextProvider = LayerDataContext.Provider

export default LayerDataContextProvider